export const APP_NAME = import.meta.env.VITE_APP_NAME || 'ISing'
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.mensageria.representacoes-ia.com'
export const WS_URL =
  import.meta.env.VITE_WS_URL ||
  API_URL.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:')

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'ising_access_token',
  REFRESH_TOKEN: 'ising_refresh_token',
  USER: 'ising_user',
  THEME: 'ising_theme',
  SIDEBAR_COLLAPSED: 'ising_sidebar_collapsed',
  ACTIVE_CHAT: 'ising_active_chat',
} as const

export const ROLES = {
  admin: { label: 'Admin', color: 'purple' },
  supervisor: { label: 'Supervisor', color: 'blue' },
  agent: { label: 'Agente', color: 'green' },
  viewer: { label: 'Visualizador', color: 'gray' },
} as const

export const INSTANCE_STATUS = {
  connected: { label: 'Conectado', color: '#10b981' },
  connecting: { label: 'Conectando', color: '#f59e0b' },
  qr_ready: { label: 'QR Pronto', color: '#3b82f6' },
  disconnected: { label: 'Desconectado', color: '#ef4444' },
} as const

export const CONVERSATION_STATUS = {
  open: { label: 'Aberta', color: '#10b981' },
  closed: { label: 'Fechada', color: '#6b7280' },
  waiting: { label: 'Aguardando', color: '#f59e0b' },
} as const

export const MESSAGE_PERIOD_OPTIONS = [
  { value: 'today', label: 'Hoje' },
  { value: 'yesterday', label: 'Ontem' },
  { value: 'week', label: 'Semana' },
  { value: 'month', label: 'Mês' },
] as const

export const RECONNECT_DELAYS = [5000, 10000, 20000, 30000, 60000] as const

export const QR_REFRESH_INTERVAL = 30_000
export const DASHBOARD_REFRESH_INTERVAL = 30_000
